import { useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import { Link } from "react-router-dom";

function formatDate(iso) {
  if (!iso) return "---";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch { return "---"; }
}

export default function Profile() {
  const { user } = useAuth();
  if (!user) return null;

  const rows = [
    ["User ID", user.user_code],
    ["Name", user.name],
    ["Email", user.email || "---"],
    ["Rank", user.rank],
    ["Sponsor ID", user.sponsor_user_code || "---"],
    ["Sponsor Name", user.sponsor_name || "---"],
    ["Activation Date", formatDate(user.activation_date)],
    ["Role", user.role],
  ];

  return (
    <div className="min-h-screen bg-slate-100">
      <Header />
      <main className="max-w-2xl mx-auto p-4 sm:p-6 space-y-4">
        <Link to="/dashboard" data-testid="profile-back" className="text-red-700 font-semibold text-sm">
          ← Back
        </Link>
        <section className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
          <div className="flex items-center gap-4">
            <div className="h-16 w-16 rounded-full bg-red-700 text-white font-black text-2xl flex items-center justify-center">
              {user.name.slice(0, 1).toUpperCase()}
            </div>
            <div>
              <div className="text-xl font-bold text-slate-900"
                   style={{ fontFamily: "Outfit, sans-serif" }}>
                {user.name}
              </div>
              <div className="text-sm text-slate-500">{user.user_code}</div>
            </div>
          </div>
          <div className="mt-6 divide-y divide-slate-100">
            {rows.map(([k, v]) => (
              <div key={k} className="py-3 flex justify-between text-sm">
                <span className="text-slate-500">{k}</span>
                <span className="font-semibold text-slate-900">{v}</span>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
